<template>
  <div class="app-shell">
    <AppHeader />
    <div class="layout">
      <AppSidebar />
      <main class="main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader'
import AppSidebar from '../components/AppSidebar'

export default {
  name: 'Full',
  components: { AppHeader, AppSidebar },
  computed: {
    name() { return this.$route.name },
    list() { return this.$route.matched },
  },
  mounted() {
    // Backup-code login flag pickup (unchanged from previous layout).
    const raw = window.sessionStorage.getItem('tfaBackupLogin')
    if (!raw) return
    window.sessionStorage.removeItem('tfaBackupLogin')
    if (!this.$bvToast) return
    let data = {}
    try { data = JSON.parse(raw) || {} } catch (e) { /* ignore */ }
    const left = data.backupCodesLeft != null ? data.backupCodesLeft : '?'
    this.$bvToast.toast(
      `Вы вошли с помощью резервного кода. Осталось кодов: ${left}. ` +
      'Перенастройте 2FA на новом устройстве в разделе «Безопасность (2FA)».',
      {
        variant: 'warning',
        title: 'Вход по резервному коду',
        autoHideDelay: 12000,
        toaster: 'b-toaster-top-center',
        solid: true,
      }
    )
  },
}
</script>

<style scoped>
.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--c-bg);
}
.layout {
  display: flex;
  min-height: calc(100vh - var(--nav-h));
}
.main {
  flex: 1;
  min-width: 0;
  padding: 24px 28px 40px;
  transition: margin-right 0.3s ease;
}
</style>
